import React from "react";
import { useTranslation } from "react-i18next";

interface IyzicoIframeComponentProps {
  iframeUrl: string;
  onGoBack: () => void;
}

const IyzicoIframeComponent: React.FC<IyzicoIframeComponentProps> = ({
  iframeUrl,
  onGoBack,
}) => {
  const { t } = useTranslation();

  return (
    <div className="iyzico-iframe-container">
      <div className="iyzico-iframe-header">
        <h3>{t("checkout.payment.iframeTitle", "Secure Payment")}</h3>
        <button onClick={onGoBack} className="go-back-button">
          {t("checkout.previous", "Previous")}
        </button>
      </div>
      <iframe
        src={iframeUrl}
        title={t(
          "checkout.payment.iyzico_checkout_form.title",
          "Credit Card / Debit Card (Iyzico)"
        )}
        frameBorder="0"
        className="iyzico-payment-iframe"
        allow="payment"
      ></iframe>
    </div>
  );
};

export default IyzicoIframeComponent;
